export default {
  turtle: {
    x: -1,
    y: -1,
    facing: null,
    boundX: 5,
    boundY: 5,
    status: ''
  }
};


// WEBPACK FOOTER //
// ./src/app/constants/InitialState.js